import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { FollowOrganizationButton } from 'components/app/FollowOrganizationButton';

export interface FollowOrganizationSectionProps {
  organizationId: string;
}

export const FollowOrganizationSection = ({
  organizationId,
}: FollowOrganizationSectionProps): ReactElement => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', mb: 32, gap: 16 }}>
    <Typography sx={{ fontFamily: 'Poppins', fontWeight: 400, fontSize: pxToEm(16), lineHeight: 1.5, textAlign: 'center', color: '#383838' }}>
      Get notified of new events
    </Typography>
    <FollowOrganizationButton organizationId={organizationId} />
  </Box>
);
